export default __webpack_public_path__ + "static/media/justrain 1.9b66495b.jpg";